(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clearSectionMotion(section) {
    if (section._mqaaarMotionObserver) section._mqaaarMotionObserver.disconnect();

    (section._mqaaarMotionTargets || []).forEach((target) => {
      target.classList.remove(
        'mqaaar-section-motion',
        'mqaaar-section-motion--fade-up',
        'mqaaar-section-motion--from-left',
        'mqaaar-section-motion--from-right',
        'mqaaar-section-motion--scale-in',
        'mqaaar-section-motion--visible'
      );
      target.style.removeProperty('--mqaaar-motion-delay');
    });

    section._mqaaarMotionTargets = [];
    section._mqaaarMotionObserver = null;
  }

  function initialiseSection(section) {
    if (section.dataset.mqaaarAnimationInitialised) return;
    clearSectionMotion(section);
    section.dataset.mqaaarAnimationInitialised = 'true';

    const chosenAnimation = window.matchMedia('(max-width: 749px)').matches
      ? section.dataset.mqaaarAnimationMobile
      : section.dataset.mqaaarAnimationDesktop;

    section.dataset.mqaaarEditorAnimation = chosenAnimation || 'none';

    /* "None" is the default and deliberately makes no visual change. */
    if (!chosenAnimation || chosenAnimation === 'none' || reducedMotion.matches) return;

    const revealTargets = [];
    const cards = Array.from(
      section.querySelectorAll(
        '.mqaaar-product-gateway__card, .mqaaar-just-for-you__card, .mqaaar-category-gateway__card, .mqaaar-culture-gateway__card'
      )
    );

    /* Product and category cards intentionally cascade one by one. */
    if (cards.length) {
      const copy = section.querySelector('[class*="__head"], [class*="__intro"]');
      if (copy) revealTargets.push([copy, chosenAnimation === 'split' ? 'from-right' : 'fade-up', 0]);
      cards.forEach((card, index) => {
        revealTargets.push([card, chosenAnimation === 'split' ? 'from-left' : chosenAnimation, 90 + index * 120]);
      });
    }

    if (chosenAnimation === 'split') {
      const copy = section.querySelector('[class*="__head"], [class*="__intro"], [class*="__content"]');
      const visual = section.querySelector('[class*="__grid"], [class*="__media"]');
      if (!cards.length && visual) revealTargets.push([visual, 'from-left', 0]);
      if (!cards.length && copy && copy !== visual) revealTargets.push([copy, 'from-right', 80]);
    }

    if (!revealTargets.length) revealTargets.push([section, chosenAnimation, 0]);

    revealTargets.forEach(([target, animation, delay]) => {
      target.classList.add('mqaaar-section-motion', `mqaaar-section-motion--${animation}`);
      target.style.setProperty('--mqaaar-motion-delay', `${delay || 0}ms`);
    });
    section._mqaaarMotionTargets = revealTargets.map(([target]) => target);

    const show = (target) => target.classList.add('mqaaar-section-motion--visible');
    if (!('IntersectionObserver' in window)) {
      revealTargets.forEach(([target]) => show(target));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          /* Each card, image, and text block reveals only when it reaches the viewport. */
          show(entry.target);
          observer.unobserve(entry.target);
        });
      },
      /* Trigger individual elements as they enter, including cards further down tall sections. */
      { rootMargin: '0px 0px -8% 0px', threshold: 0 }
    );
    section._mqaaarMotionObserver = observer;
    revealTargets.forEach(([target]) => observer.observe(target));
  }

  function initialise(container = document) {
    container.querySelectorAll('[data-mqaaar-animation-desktop]').forEach(initialiseSection);
  }

  function restartSection(section) {
    if (!section) return;
    const animatedSection = section.matches('[data-mqaaar-animation-desktop]')
      ? section
      : section.querySelector('[data-mqaaar-animation-desktop]');
    if (!animatedSection) return;
    delete animatedSection.dataset.mqaaarAnimationInitialised;
    clearSectionMotion(animatedSection);
    initialiseSection(animatedSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  /* Selecting a section in Shopify's editor should replay its preview, not retain a finished animation. */
  document.addEventListener('shopify:section:select', (event) => restartSection(event.target));
  document.addEventListener('shopify:section:reorder', () => initialise());

  /* Theme editor can update a setting in place rather than replace the section. */
  if (window.Shopify && Shopify.designMode && 'MutationObserver' in window) {
    new MutationObserver((changes) => {
      changes.forEach((change) => {
        restartSection(change.target);
      });
    }).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-mqaaar-animation-desktop', 'data-mqaaar-animation-mobile'],
    });
  }
})();
